import NearbyStores from "components/nearbyStores/NearbyStores";
import StoresLogos from "components/shared/storesLogos/StoresLogos";
import { StoresStyled, Wrapper, Title, Text, Separator } from "./Stores.styled";

export default function Stores() {
    return (
        <StoresStyled>
            <Wrapper>
                <Title>Lees! Cadeaukaart inwisselen</Title>
                <Text>
                    Bekijk hier bij welke winkels en webshops de Lees!
                    Cadeaukaart in te wisselen is.
                </Text>
                <StoresLogos isRedeem />
            </Wrapper>

            <Separator />

            <Wrapper bottom>
                <NearbyStores
                    subject="Acceptant"
                    title="Een acceptant bij jou in de buurt"
                    description="Liever in een winkel inwisselen? Dat kan natuurlijk ook!"
                    onlyRedeemStores
                    cityOnly
                />
            </Wrapper>
        </StoresStyled>
    );
}
